'use strict';

frontendApp.directive('iioTagBooleanItem', ['TagService', 'NotificationService', function (TagService, NotificationService) {
  return {
    restrict: 'E',
    templateUrl: 'partials/tagging/tag_boolean_item.html',
    scope: {
      selected: '=',
      tags: '=',
      project: '='
    },
    link: function (scope, element, attrs) {
      if (!scope.selected) {
        scope.selected = [];
      }

      scope.title = attrs.title;

      attrs.$observe('name', function (val) {
        scope.name = val;
      });

      attrs.$observe('admin', function (val) {
        scope.adminTags = val;
      });

      attrs.$observe('inverse', function (val) {
        scope.isInverse = val;
      });

      attrs.$observe('child', function (val) {
        scope.isChild = val;
      });

      scope.$watch('tag', function (val) {
        scope.validTag = _.isObject(val);
      });

      scope.add = function () {
        if (!scope.validTag) return;

        scope.selected.push(scope.tag);
        scope.tag = '';
      };

      scope.getSuggestions = function (val) {
        var categoryBitmask = 23; // all categories minus collection tags, (10111) batch,coll,proj,dom,sys
        if (scope.adminTags)
          categoryBitmask = 4;
        if (scope.isInverse) {
          return TagService.GetSuggestions(scope.project.id, val, categoryBitmask, true, false).then(function (response) {
            return response.data;
          });
        } else if (scope.isChild) {
          return TagService.GetSuggestions(scope.project.id, val, categoryBitmask, false, false, true).then(function (response) {
            return response.data;
          });
        } else {
          return TagService.GetSuggestions(scope.project.id, val, categoryBitmask).then(function (response) {
            return response.data;
          });
        }

      };

      scope.$on('RemoveTag', function (evt, tag, index) {
        evt.stopPropagation();
        scope.selected.splice(index, 1);
      });

    }
  }
}]);
